import { NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { KENDO_TEXTBOX } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { UnityRouteUrlTrees } from '@unity/utils/types';

@Component({
  selector: 'unity-gridcell-clickable-shared',
  standalone: true,
  imports: [KENDO_LABEL, KENDO_TEXTBOX, RouterLink, NgTemplateOutlet],
  templateUrl: './gridcell-clickable-shared.component.html',
  styleUrl: './gridcell-clickable-shared.component.scss',
})
export class GridcellClickableSharedComponent {
  public readonly $link = input.required<UnityRouteUrlTrees>({ alias: 'link' });

  public readonly $labelText = input<string>(undefined, { alias: 'labelText' });
  public readonly $displayText = input<string>(undefined, { alias: 'displayText' });
}
